<template>
  <div class="text-xs-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      lazy
      max-width="350"
    >
      <template #activator="{ on }">
        <v-btn flat icon v-on="on">
          <v-icon>tune</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-layout wrap row pa-3>
          <v-flex xs12 px-2>
            <v-select
              v-model="localFilters.type"
              :items="types"
              :label="$tc('models.typeEvent')"
              clearable
              multiple
            />
          </v-flex>
          <v-flex xs12 px-2>
            <v-select
              v-model="localFilters.group"
              :items="eventGroups"
              :label="$tc('models.group')"
              clearable
            />
          </v-flex>
          <v-divider />
        </v-layout>

        <!-- <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            flat
            @click="search"
            :loading="$store.state.teams.loading"
            >{{ $t('action.buttons.search') }}</v-btn
          >
        </v-card-actions> -->
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'TypeEventsFilters',
  data: () => ({
    menu: false,
  }),

  computed: {
    ...mapState({
      filters: (state) => state.typeEvents.filters,
    }),
    ...mapGetters({
      types: 'typeEvents/types',
      eventGroups: 'typeEvents/groups',
    }),
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('typeEvents/setFilters', value)
      },
    },
  },
}
</script>
